<template>
  <div class="orderby">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>海运下单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top:20px">
      <!-- 步骤条 -->
      <el-steps :active="active" finish-status="success">
        <el-step title="必填" description="此处信息必填哦，最快十秒内完成"></el-step>
        <el-step title="选填" description="生成唛头和入仓单，仓库优先装柜哦"></el-step>
        <el-step title="成功"></el-step>
      </el-steps>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <!-- 必填 -->
        <div v-show="active==0">
          <!-- 基本信息 --> 
          <el-card class="activeOne">
            <div slot="header" class="clearfix">
              <b>
                <i class="el-icon-document"></i>基本信息
              </b> 
            </div>
            <!-- 运单号 -->
            <div class="top">
              <div class="top-input">
                <div class="lable">
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="必填"
                    placement="top-start"
                  >
                    <el-tag type="warning" style="width:20px;margin-right:4px;color:red">!</el-tag>
                  </el-tooltip> -->
                  <i class="bitian">*</i>运单编号:
                </div>
                <el-tooltip class="item" effect="dark" content="运单号。也叫参考号,货件号,用于业务对接.(如：FBAID)" placement="top">
                <el-form-item style="display: inline-block;margin-left:10px" prop="topWaybill">
                  <el-input placeholder="5-16位字符，禁止空格" v-model="ruleForm.topWaybill" type="text" maxlength="18" show-word-limit></el-input>
                </el-form-item></el-tooltip>
              </div>
            </div>
            <div class="top">
              <div class="top-input">
                <div class="lable"><i class="bitian">*</i>渠道方式:</div>
                <el-tooltip class="item" effect="dark" content="支持EMC/以星/美森/专线搜索" placement="top">
                <el-form-item style="display: inline-block;margin-left:10px" prop="topChannel">
                  <el-select v-model="ruleForm.topChannel" clearable filterable  placeholder="请选择"  >
                    <el-option-group
                      v-for="group in ruleForm.channelData"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="(item,index) in group.options"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item></el-tooltip>
              </div>
              <div class="top-input">
                <div class="lable">报关方式:</div>
                <el-tooltip class="item" effect="dark" content="退税方式记得找我们要报关行代码，并进行委托" placement="top">
                <el-form-item style="display: inline-block;margin-left:10px">
                  <el-select v-model="ruleForm.topDeclare" placeholder="请选择" @change="topDe">
                    <el-option
                      v-for="item in ruleForm.declareData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                </el-tooltip>
              </div>
              <div class="top-input">
                <div class="lable">海运方式:</div>
                <el-form-item style="display: inline-block;margin-left:10px">
                  <el-cascader
                    v-model="ruleForm.topOcean"
                    :options="ruleForm.oceanData"
                    @change="oceanShip"
                    :props="{ value: 'name', label: 'name'}"
                    placeholder="请选择"
                  ></el-cascader>
                </el-form-item>
              </div>
            </div>
            <div class="top">
              <!-- 送货地 -->
              <div class="top-input">
                <div class="lable"><i class="bitian">*</i>送货仓库:</div>
                <el-form-item style="display: inline-block;margin-left:10px" prop="cenPlace">
                  <el-select v-model="ruleForm.cenPlace" placeholder="请选择" @change="cenPl">
                    <el-option-group
                      v-for="group in ruleForm.placeData"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="(item,index) in group.options"
                        :key="index"
                        :label="item.cname"
                        :value="item.cname"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                  <!-- <el-cascader :show-all-levels="false" filterable :options="options"  v-model="ruleForm.cenPlace" placeholder="请选择" @change="cenPl">
                    <el-cascader-panel
                      v-for="group in ruleForm.placeData"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-cascader-children
                        v-for="(item,index) in group.options"
                        :key="index"
                        :label="item.cname"
                        :value="item.cname"
                      ></el-cascader-children>
                  </el-cascader-panel>
                  </el-cascader> -->
                </el-form-item>
                <div class="text">
                  <p v-html="textVal"></p>
                </div>
              </div>
              <!-- 送货时间 -->
              <div class="top-input">
                <div class="lable"><i class="bitian">*</i>送货时间:</div>
                <el-tooltip class="item" effect="dark"  content="预计到仓的时间/方便仓库接收留人" placement="top">>
                <el-form-item style="display: inline-block;margin-left:10px" prop="dispatchTime">
                  <el-date-picker
                    v-model="ruleForm.dispatchTime"
                    type="date"
                    placeholder="选择日期时间"
                    @change="dispatchTime"
                    :picker-options="pickerOptions"
                    default-time="00:00:00"
                    format="yyyy-MM-dd HH:mm:ss"
                    :disabled="ruleForm.cenPlace==''"
                  ></el-date-picker>
                </el-form-item></el-tooltip>
              </div>
              <!-- 进口商 -->
              <div class="top-input">
                <div class="lable">进口商:</div>
                <el-form-item style="display: inline-block;margin-left:10px">
                  <el-select v-model="ruleForm.cenImported" placeholder="请选择" @change="cen" disabled>
                    <el-option label="公司进口商" :value="1"></el-option>
                    <el-option
                      v-for="(item,index) in ruleForm.importedData"
                      :key="index"
                      :label="item.name"
                      :value="公司进口商"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <!-- 发货人 -->
              <div class="top-input">
                <div class="lable">Shipper:</div>
                <el-form-item style="display: inline-block;margin-left:10px">
                  <el-select v-model="ruleForm.cenDeliver" placeholder="请选择" @change="cenDe" disabled id="jinkoushang">
                    <el-option
                      v-for="(item,index) in ruleForm.deliverData"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <!-- radio -->
            <div class="radio">
              <div class="radio-cent">
                <div class="lable"><i class="bitian">*</i>目的仓:</div>
                <el-radio-group @change="radioVal" v-model="radio">
                  <el-radio :label="0" v-show="orderType0">FBA地址</el-radio>
                  <el-radio :label="1" v-show="orderType1">私人地址</el-radio>
                  <el-radio :label="2" v-show="orderType2">三方仓</el-radio>
                  <el-radio :label="3" v-show="orderType3">留仓</el-radio>
                  <el-radio :label="4" v-show="orderType4">传统</el-radio>
                  <el-radio :label="5" v-show="orderType5">一件代发</el-radio>
                </el-radio-group>
              </div>
              <div class="radio-cent">
                <div v-show="radio==0">
                  <div class="lable">仓库代码:</div>
                  <el-form-item prop="wareCode">
                    <el-select
                      class="wareselect"
                      v-model="ruleForm.wareCode"
                      filterable
                      placeholder="请选择"
                      @change="wareDataAddress"
                    >
                      <el-option
                        v-for="(item,index) in ruleForm.wareData"
                        :key="index"
                        :label="item.lable"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <i class="el-icon-location-information" v-html="addressInfo"></i>
                </div>
                <!-- 私人地址 -->
                <div v-show="radio==1">
                  <div>
                    <div class="lable">国家:</div>
                    <el-form-item prop="country">
                      <country
                        class="country"
                        placeholder="请输入国家"
                        :countrys="ruleForm.country"
                        @getCty="getCountry"
                      ></country>
                    </el-form-item>
                  </div>
                  <div>
                    <div class="lable">收件人:</div>
                    <el-form-item prop="addressee">
                      <el-input placeholder="请输入收件人" v-model="ruleForm.addressee"></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <div class="lable">州:</div>
                    <el-form-item prop="state">
                      <el-input placeholder="请输入州" v-model="ruleForm.state"></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <div class="lable">邮编:</div>
                    <el-form-item prop="addzip">
                      <el-input placeholder="请输入邮编" v-model="ruleForm.addzip"></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <div class="lable">联系电话:</div>
                    <el-form-item prop="telPhone">
                      <el-input placeholder="请输入联系电话" v-model="ruleForm.telPhone"></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <div class="lable">地址:</div>
                    <el-form-item prop="address">
                      <el-input placeholder="请输入详细地址" type="textarea" v-model="ruleForm.address"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div v-show="radio==2">
                  <div class="lable">仓库代码:</div>
                  <el-form-item prop="whCode">
                    <el-select
                      class="wareselect"
                      v-model="ruleForm.whCode"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item,index) in ruleForm.whData"
                        :key="index"
                        :label="item.lable"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-show="radio==3">
                  <div class="lable">留仓代码:</div>
                  <el-form-item prop="whHoldCode">
                    <el-select
                      class="wareselect"
                      v-model="ruleForm.whHoldCode"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item,index) in ruleForm.whHoldData"
                        :key="index"
                        :label="item.lable"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-show="radio==4">
                  <div class="lable">传统:</div>
                  <el-form-item prop="endPort">
                    <el-select
                      class="wareselect"
                      v-model="ruleForm.endPort"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item,index) in ruleForm.endPortList"
                        :key="index"
                        :label="item.portChinese +'/'+ item.portEnglish +'/'+ item.portFive"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-show="radio==5">
                  <div class="lable">一件代发:</div>
                  <el-form-item prop="wholesaleCode">
                    <el-select
                      class="wareselect"
                      v-model="ruleForm.wholesaleCode"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item,index) in ruleForm.wholesaleData"
                        :key="index"
                        :label="item.lable"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div >
              <div>
              </div>
            </div>
          </el-card>
          <!-- 产品申报 -->
          <el-card class="activeOne">
            <div slot="header" class="clearfix">
              <div style="line-height:32px">
                <b>
                  <i class="el-icon-document"></i>产品申报
                </b>
              </div>
              <el-link style="margin-left:20px" type="primary" icon="el-icon-download" :href="apiAction(0)">下载产品模板</el-link>
            </div>
            <div class="product" style="overflow: hidden;">
              <el-upload
                class="upload-demo"
                drag
                :action="apiAction(1)"
                multiple
                :on-success="handProduct"
                :on-remove="handRemove"
                :limit="1"
                name="upload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div style="margin-top:20px">
              <div class="tips">
                <span>总数量：{{ qty }}</span>
                <span>总申报价值：{{ totalValue }}</span>
              </div>
              <el-table size="mini" :data="ruleForm.master_userArr" border style="width: 100%">
                <el-table-column align='center' fixed>
                  <template slot="header">
                    <el-link
                      type="primary"
                      size="mini"
                      :underline="false"
                      icon="el-icon-circle-plus-outline"
                      @click="addRow">添加</el-link>
                  </template>
                  <template slot-scope="scope">
                    <!-- <span
                      class="el-tag el-tag--danger el-tag--mini"
                      style="cursor: pointer;"
                      @click="deleteRow(scope.$index,ruleForm.master_user.data,ruleForm.master_userArr)"
                    ></span> -->
                    <el-link
                      type="danger"
                      size="mini"
                      :underline="false"
                      @click="deleteRow(scope.$index,ruleForm.master_user.data,ruleForm.master_userArr)"
                    >移除</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="中文名" width="120" fixed>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="英文名" width="120" fixed>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.ename"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="材质" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.material"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="用途" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.purpose"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="报关编码HS" width="120" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.hscode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="清关编码" width="120" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.gwcode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="税率" width="120" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.taxRate"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="带电带磁" width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.electrificationState" clearable placeholder="请选择">
                      <el-option
                        v-for="item in ruleForm.master_user.eleData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.brand"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="品牌类型" width="180">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.brandType" clearable placeholder="请选择">
                      <el-option
                        v-for="item in ruleForm.master_user.btData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="型号" width="120">
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.model"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="件数" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.ctn"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.ctn"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.qty"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.qty"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="USD单价" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.unitValue"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.unitValue"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="申报总价" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入申报总价" v-model="scope.row.totalValue"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.totalValue"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="净重" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.nkg"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.nkg"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="实重" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入实重" v-model="scope.row.kg"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.kg"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="尺寸" width="150">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.size"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="总体积" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入总体积" v-model="scope.row.cbm"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.cbm"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="唛头序号" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.markNo"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="产品标" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.fnsku"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="链接" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.selleLink"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="图片">
                  <template slot-scope="scope">
                    <el-upload
                      name="upload"
                      style="text-align:center"
                      :action="apiAction(2)"
                      :show-file-list="false"
                      :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList, scope.$index)"
                      :before-upload="beforeUpload"
                      :file-list="fileList"
                      list-type="picture"
                      :headers="myHeaders"
                    >
                      <el-button v-if="scope.row.picUrl == ''" type="text">
                        上传<i class="el-icon-upload el-icon--right"></i>
                      </el-button>
                      <img v-else style="width:100%" :src="scope.row.picUrl" />
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top:20px">
              <el-button type="primary" @click="addList">添加已有产品</el-button>
              <el-dialog
                title="添加已有产品"
                :visible.sync="dialogVisible"
                center>
                <el-table
                :data="productData"
                @selection-change="selectData"
                ref="multipleTable"
                @row-click="handleRowClick"
                style="width: 100%">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="中文名称" prop="name"></el-table-column>
                  <el-table-column label="英文名称" prop="ename"></el-table-column>
                  <el-table-column label="国家" prop="country"></el-table-column>
                  <el-table-column label="报关编码" prop="hscode"></el-table-column>
                  <el-table-column label="清关编码" prop="gwcode"></el-table-column>
                  <el-table-column label="税率" prop="taxRate"></el-table-column>
                  <el-table-column label="材质" prop="material"></el-table-column>
                  <el-table-column label="用途" prop="purpose"></el-table-column>
                  <el-table-column label="品牌" prop="brand"></el-table-column>
                  <el-table-column label="产品标" prop="fnsku"></el-table-column>
                  <el-table-column label="链接" prop="selleLink" width="120"></el-table-column>

                </el-table>
                <div class="block" style="margin-top:20px;text-align:center">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 40,60, 80,100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="add">确 定</el-button>
                </span>
              </el-dialog>
            </div>
          </el-card>
          <!-- 预约号 -->
          <el-card class="activeOne" v-show="radio==0">
            <div slot="header" class="clearfix">
              <div style="line-height:32px">
                <b>
                  <i class="el-icon-document"></i>预约号/货件ID
                </b>
              </div>
              <!-- <el-link style="margin-left:20px" type="primary" icon="el-icon-download" >导入ID</el-link> -->

              <el-upload
                class="upload-demo"
                :action="apiAction(3)"
                :on-success="handShipmentId"
                :show-file-list="noList"
                 multiple
                :limit="1"
                name="upload">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
                <span style="margin-left: 10px;margin-top: 10px;">当前预约号条数： {{  ruleForm.order_user.length }}</span>
               <el-link style="margin-left:20px" type="primary" icon="el-icon-download" :href="apiAction(4)">下载预约号模板</el-link>
            </div>
            <div class="subScribe">
              <table class="gridtable">
                <thead>
                  <tr>
                    <th>
                      <el-button class="th" type="text" size="mini" @click="insert" icon="el-icon-circle-plus-outline">添加</el-button>
                    </th>
                    <th>
                      <span class="th">跟踪号/FBA</span>
                    </th>
                    <th>
                      <span class="th">内部跟踪号</span>
                    </th>
                    <th>
                      <span class="th">件数CTN</span>
                    </th>
                    <th>
                      <span class="th">重量KGS</span>
                    </th>
                    <th>
                      <span class="th">体积CBM</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user,index) in ruleForm.order_user" :key="index">
                    <td style="text-align:center">
                      <el-link
                        type="danger"
                        size="mini"
                        :underline="false"
                        @click="remove(index)"
                      >移除</el-link>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.shipmentid" title="亚马逊后台建立的货件号，还未有货件填1补充" placeholder="shipment id"/>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.referenceid" placeholder="reference id"/>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.ctn" />
                    </td>
                    <td>
                      <!-- <el-input size="mini" v-model="user.kg.toFixed(2)" /> -->
                      <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.kg"></el-input-number>
                    </td>
                    <td>
                      <!-- <el-input size="mini" v-model="user.cbm.toFixed(2)" /> -->
                      <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.cbm"></el-input-number>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-card>
          <!-- 下一步 -->
          <el-form-item style="margin-top: 20px;text-align: center">
            <el-button type="primary" size="medium" @click="next('ruleForm')">下一步<i class="el-icon-arrow-right el-icon--right"/></el-button>
          </el-form-item>
        </div>
        <!-- 选填 -->
        <div v-show="active==1">
          <el-card class="activeTwo">
            <div slot="header" class="clearfix">
              <b>
                <i class="el-icon-document"></i>增值服务
              </b>
            </div>
            <div class="switch">
              <div class="sw_cent">
                <div class="label" style="margin-right: 10px">
                  <span>是否提货</span>
                </div>
                <el-switch v-model="takeVal" @change="take"></el-switch>
              </div>
              <div class="sw_cent">
                <div class="label" style="margin-right: 10px">
                  <span>购买保险</span>
                </div>
                <el-switch v-model="InsuranceVal" @change="Insurance"></el-switch>
              </div>
            </div>
            <div class="take" v-show="takeVal">
              <div class="take-cent">
                <div>
                  <span><i class="red">*</i> 取货信息:</span>
                  <el-input v-model="factoryVal" placeholder="请输入xxx工厂"></el-input>
                  <el-input v-model="telVal" placeholder="请输入电话"></el-input>
                </div>
                <div class="take-time">
                  <span><i class="red">*</i> 取货时间:</span>
                  <el-date-picker
                    v-model="creteTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    @change="pickTime"
                    :picker-options="pickerOptions"
                    default-time="12:00:00"
                    format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                </div>
                <div>
                  <span><i class="red">*</i> 取货地址:</span>
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addressVal"></el-input>
                </div>
                <div>
                  <span>取货备注:</span>
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ramakVal"></el-input>
                </div>
              </div>
            </div>
            <div class="insurance" v-show="InsuranceVal">
              <div>
                <span><i class="red">*</i> 公司名称:</span>
                <el-input v-model="insurancePeople" placeholder="请输入您的公司全称"></el-input>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="保险额度:不能超过真实成本的110%，保险费用按保额的千分之五收取，优惠咨询业务"
                  placement="top-start"
                >
                  <el-tag type="warning">!</el-tag>
                </el-tooltip>
                <span><i class="red">*</i> 保险额度:</span>
                <el-input v-model="insuranceQuota" placeholder="请输入额度"></el-input>
                <span><i class="red">*</i> 保险币种:</span>
                <el-select
                  v-model="insuranceCurrency"
                  filterable
                  clearable
                  placeholder="请选择币种"
                  size="small"
                >
                  <el-option
                    v-for="(item,index) in insuranceCurrencys"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span><i class="red">*</i> 上架保障:</span>
                <el-select
                  v-model="shelf"
                  filterable
                  clearable
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="(item,index) in shelfList"
                    :key="index"
                    :disabled="item.disabled"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="remake">
              <span >备注:</span>
              <el-input 
              v-model="ruleForm.inputValue" 
              placeholder="费用报价/特殊要求/船期保舱/ASIN链接/VAT"
              type="textarea"
              :rows="3"
              ></el-input>
              <div class="tag">
                <el-tag
                  :key="tag"
                  v-for="tag in dynamicTags"
                  size="small"
                  @click="getTag(tag)"
                >{{tag}}</el-tag>
              </div>
            </div>
          </el-card>
          <!-- 下一步 -->
          <el-form-item style="margin-top: 20px;text-align: center">
            <el-button type="" size="medium" @click="formNext" icon="el-icon-arrow-left">上一步</el-button>
            <el-button type="primary" size="medium" @click="submitForm" icon="el-icon-check">立即创建</el-button>
          </el-form-item>
        </div>
        <!-- 生成订单 -->
        <div v-show="active==3">
          <el-card class="activeThree">
            <!-- <div>
              <el-button type="primary" @click="getMaitou" icon="el-icon-download">唛头</el-button>
              <span style="margin-left:20px">唛头每箱货贴一张</span>
            </div> -->
            <div>
              <el-button type="success" icon="el-icon-download" @click="getMaitou" >下载唛头</el-button>
              <span style="margin-left:20px"><b>唛头：</b>每箱货贴一张，方便分货，优先装柜，优先派送</span><span style="color:red">（代贴：1元/箱）</span>
            </div>
            <div>
              <el-button type="primary" @click="getRucangdan" icon="el-icon-download">入仓单</el-button>
              <span style="margin-left:20px"><b>入仓单：</b>打印一份，由司机带进仓库，作为入仓登记。</span><span style="color:red">（代打：10元/张）</span>
            </div>
            <div>
              <el-button type="success" @click="toNext">订单完成</el-button>
            </div>
          </el-card>
        </div>
      </el-form>
    </el-card>
    <el-dialog
      class="abnormal"
      title="唛头下载"
      :visible.sync="dialogFormVisible3"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-select v-model="marks" clearable placeholder="请选择唛头模板" value-key="id">
          <el-option
            v-for="(item,index) in options3"
            :key="index"
            :label="item.marks"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="getMaitou2()">单张唛头</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="abnormal"
      title="送货时间"
      :visible.sync="dialogFormVisible4"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="640px"
      center
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-row :gutter="20" style="margin:0;">
            <el-col :span="20">
              <el-date-picker
                v-model="ruleForm.dispatchTime"
                type="date"
                placeholder="选择日期时间"
                @change="dispatchTime"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd HH:mm:ss"
                default-time="00:00:00"
                style="width:100%;border-radius: 0;"
              ></el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" style="width:100%;border-radius: 0;" @click="dialogFormVisible4 = false">确 认</el-button>
            </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="width:600px;">
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(8)" :disabled="isDisabled('08')" class="grid-content bg-purple">8:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(9)" :disabled="isDisabled('09')" class="grid-content bg-purple">9:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(10)" :disabled="isDisabled('10')" class="grid-content bg-purple">10:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(11)" :disabled="isDisabled('11')" class="grid-content bg-purple">11:00</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(13)" :disabled="isDisabled('13')" class="grid-content bg-purple">13:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(14)" :disabled="isDisabled('14')" class="grid-content bg-purple">14:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(15)" :disabled="isDisabled('15')" class="grid-content bg-purple">15:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(16)" :disabled="isDisabled('16')" class="grid-content bg-purple">16:00</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(17)" :disabled="isDisabled('17')" class="grid-content bg-purple">17:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(18)" :disabled="isDisabled('18')" class="grid-content bg-purple">18:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(19)" :disabled="isDisabled('19')" class="grid-content bg-purple">19:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(20)" :disabled="isDisabled('20')" class="grid-content bg-purple">20:00</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var token = sessionStorage.getItem("token");
//引入api
import httpApi from "@/http/api"
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country
  },
  data() {
    // 自定义校验
    var checkClientNo = (rule, value, callback) => {
      const regClientNo =  /^\s*\S+\s*$/;
      if (regClientNo.test(value)) {
        return callback();
      }
      return callback("运单号中间不能有空格，可用-代替空格");
    };
    return {
      responseDataUp: null,
      orderType0: true,
      orderType1: true,
      orderType2: true,
      orderType3: true,
      orderType4: true,
      orderType5: true,
      noList: false,
      myHeaders: { token: token },
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      day:"",
      timeData: [],
      options3: [],
      marks: {},
      fileList: [], //上传图片列表
      rules: {
        topWaybill: [
          { required: true, message: "请输入运单号", trigger: "blur" },
          { validator: checkClientNo, trigger: "blur" },
        ],
        topChannel: [
          { required: true, message: "请选择渠道方式", trigger: "change" }
        ],
        wareCode: [
          { required: true, message: "请选择仓库代码", trigger: "change" }
        ],
        whCode: [
          { required: false, message: "请选择自提代码", trigger: "change" }
        ],
        whHoldCode:[
          { required: false, message: "请选择留仓代码", trigger: "change" }
        ],
        endPort:[
          { required: false, message: "请选择传统代码", trigger: "change" }
        ],
        wholesaleCode:[
          { required: false, message: "请选择一件代发代码", trigger: "change" }
        ],
        country: [
          { required: false, message: "请选择国家", trigger: "change" }
        ],
        addressee: [
          { required: false, message: "请输入收件人", trigger: "blur" }
        ],
        state:[
          { required: false, message: "州必填", trigger: "blur" }
        ],
        addzip:[
          { required: false, message: "邮编必填", trigger: "blur" }
        ],
        telPhone: [
          { required: false, message: "请输入电话", trigger: "blur" }
        ],
        address: [
          { required: false, message: "请输入地址", trigger: "blur" }
        ],
        cenPlace: [
          { required: true, message: "请选择送仓地", trigger: "change" }
        ], //送货地
        dispatchTime: [
          { required: true, message: "请选择送货时间", trigger: "blur" }
        ]
      },
      qty: "0",
      totalValue: "0",
      ruleForm: {
        topWaybill: "", //运单号
        topChannel: "", //渠道方式
        channelData: [],
        topDeclare: "0", //报关方式
        topDeclVal: "0",
        declareData: [
          { label: "买单", value: "0" },
          { label: "退税", value: "1" }
        ],
        topOcean: ["拼柜"], //海运方式
        oceanData: [
          {
            id: "0",
            name: "拼柜"
          },
          {
            id: "1",
            name: "整柜",
            children: []
          }
        ],
        topOceanNum: "0", //拼柜整柜
        topOceanType: "", //整柜类型
        cenPlace: "", //送货地
        cenId: "", //送货地id
        placeData: [],
        cenPlaceText: "", //送货名字
        dispatchTime: "", //送货时间
        cenDeliver: "", //发货人
        cenDelivertext: "", //发货人名字
        deliverData: [],
        cenImported: "", //进口商
        cenImporVal: "1", //进口商默认
        cenImportext: "", //显示名字
        cenImporValue: "", //进口商参数
        importedData: [],
        wareCode: "", //仓库代码
        wareData: [],
        whCode: "", //自提
        whData: [], //自提货数据
        whHoldCode: "", //留仓
        whHoldData: [], //留仓数据
        endPort: "",
        endPortList: [],
        wholesaleCode: "", //一件代发
        wholesaleData: [], //一件代发数据
        country: "", //国家
        addressee: "", //收件人
        state: "",//州
        addzip:"",//私人地址邮编
        telPhone: "", //联系电话
        address: "", //详细地址
        inputValue: "", //备注
        master_user: {
          sel: null, //选中行EW
          eleData: [
            { label: "否", value: "0" },
            { label: "只带电", value: "1" },
            { label: "只带磁", value: "2" },
            { label: "带电带磁", value: "3" }
          ],
          btData: [
            { label: "无品牌", value: "0" },
            { label: "境内自主品牌", value: "1" },
            { label: "境内收购品牌", value: "2" },
            { label: "境外品牌(贴牌生产)", value: "3" },
            { label: "境外品牌(其他)", value: "4" }
          ],
          data: []
        },
        master_userArr: [],
        order_user: [
          { shipmentid: "", referenceid: "", ctn: 0, kg: 0, cbm: 0 }
        ],
        order_userArr: {
          shipmentid: "",
          referenceid: "",
          ctn: "",
          kg: "",
          cbm: ""
        },
      },
      active: 0, //步骤条
      radio: 5, //地址
      textVal: "", //送货仓
      addressInfo: "", //代码地址
      dynamicTags: [], //备注
      //选题
      takeVal: false, //需要提货
      pickupType: "0", //提货0-1
      pickObj: {},
      pickupList: [], //提货参数
      InsuranceVal: false, //需要保险
      insurance: "0", //保险0-1
      insuranceCurrency: "",//保险币种
      insuranceCurrencys: [
        {label:"人民币",value:"CNY"},
        {label:"美元",value:"USD"},
        {label:"欧元",value:"EUR"},
        {label:"英镑",value:"GBP"},
        {label:"港元",value:"HKD"}
      ],
      shelf: "",
      shelfList: [
        {key:"不保上架",value:"NONE",disabled:false},
        {key:"保上架(整箱)",value:"FCL",disabled:false},
        {key:"保上架(整箱/单个)",value:"SINGLE",disabled:true},
        {key:"只保上架(整箱)",value:"ONLY_FCL",disabled:false},
        {key:"只保上架(单个)",value:"ONLY_SINGLE",disabled:true},
      ],
      factoryVal: "", //工厂
      telVal: "",
      creteTime: "", //取货时间
      addressVal: "", //地址
      ramakVal: "", //备注
      insurancePeople: "", //保险人
      insuranceQuota: "", //保险额度
      orderVal: "", //成功生成得订单号
      //复制下单
      copyData: {}, //复制订单详情
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        }
      },
      imageUrl: '',
      goodsNullList: {
        name: "",
        ename: "",
        material: "",
        purpose: "",
        hscode: "",
        gwcode: "",
        taxRate: "",
        electrificationState: "0",
        brand: "无",
        brandType: "0",
        model: "无",
        ctn: 1,
        qty: 0.00,
        unitValue: "",
        totalValue: "",
        nkg: "",
        kg: "",
        size: "",
        cbm: "",
        picUrl: ""
      },
      dialogVisible: false,
      productData: [], //产品列表
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      inputVal: "",
      selectDatas: "",
    };
  },
  methods: {
    isDisabled(v){
      let a = "";
      this.timeData.forEach(i=>{
        if(i.name == v){
          a = i.value;
        }
      })
      return a=="true";
    },
    apiAction(type){
      if(type == "1"){
        return this.mApi + "/file/parseExcel/goods"
      }else if(type == "2"){
        return this.mApi + "/file/upload"
      }else if(type == "0"){
        return this.mApi + "/file/goodsTemplate"
      }else if(type == "3"){
        return this.mApi + "/file/parseExcel/shipment"
      }else if(type == "4"){
        return this.mApi + "/file/shipmentTemplate"
      }
    },
    //下一步(正则)
    next(formName) {
      let that = this;
      if(that.ruleForm.topWaybill.length < 7){
        that.$message.error("运单号不能小于7位");
      }else{
        that.$refs[formName].validate(valid => {
          if (valid) {//表单数据校验
            let notRequiredArr = ["markNo","fnsku","selleLink"]
            if (that.ruleForm.master_user.data.length > 0) {
              let arr = that.ruleForm.master_userArr
              for (const i in arr) {
                //产品申报信息校验
                for (const key in arr[i]) {
                  let reg = /^(([0-9]+[\.]?[0-9]+)|[1-9])$/
                  if (arr[i][key] === "" && !notRequiredArr.includes(key)) {
                    that.$message.error("产品申报信息不能为空");
                    return false;
                  }else if(!reg.test(arr[i]["ctn"])){
                    that.$message.error("件数必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["qty"])){
                    that.$message.error("数量必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["unitValue"])){
                    that.$message.error("单价必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["totalValue"])){
                    that.$message.error("总价必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["nkg"])){
                    that.$message.error("净重必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["kg"])){
                    that.$message.error("实重必须为正数");
                    return false;
                  }else if(!reg.test(arr[i]["cbm"])){
                    that.$message.error("体积必须为正数");
                    return false;
                  }
                }
                //预约号校验
                if(i == arr.length-1) {
                  if(this.radio == 0){
                      let flag = true;
                    for (const o in this.ruleForm.order_user) {
                            if (this.ruleForm.order_user[o].shipmentid == "" || this.ruleForm.order_user[o].referenceid == "") {
                                that.$message.error("请填写完整预约号信息");
                                flag = false;
                                break
                            }else if(isNaN(this.ruleForm.order_user[o].ctn) || isNaN(this.ruleForm.order_user[o].kg) || isNaN(this.ruleForm.order_user[o].cbm) || this.ruleForm.order_user[o].ctn == 0 || this.ruleForm.order_user[o].kg == 0 || this.ruleForm.order_user[o].cbm == 0){
                                that.$message.error("预约号信息出错");
                                flag = false;
                                break
                            }
                    }
                    if(flag){
                        this.analysis();
                        that.active = 1;
                    }
                  }else{
                    this.ruleForm.order_user = [];
                    this.analysis();
                    that.active = 1;
                  }
                }
              }
            } else {
              that.$message.error("请添加产品申报");
              this.analysis();
              return false;
            }
          } else {
            that.$message.error("请填写完整信息");
            return false;
          }
        });
      }
    },
    //上一步
    formNext() {
      this.active -= 1;
    },
    //订单完成
    toNext() {
      this.active = 0;
      this.$router.push("/orderby2");
    },
    //提交订单
    submitForm() {
      let that = this;
      let shipmentCode = "";
      if (that.ruleForm.wareCode != "") {
        shipmentCode = that.ruleForm.wareCode;
      } else if (that.ruleForm.whCode != "") {
        shipmentCode = that.ruleForm.whCode;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.whHoldCode != "") {
        shipmentCode = that.ruleForm.whHoldCode;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.endPort != "") {
        shipmentCode = that.ruleForm.endPort;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.wholesaleCode != "") {
        shipmentCode = that.ruleForm.wholesaleCode;
        that.ruleForm.order_user = [];
      }
      that.pickupList = [];
      let time = "";
      time = that.ruleForm.dispatchTime / 1000;
      let tf = true;
      if (that.takeVal) {
        // that.pickObj.geteTime = that.pickObj.geteTime / 1000;
        that.pickObj.getsTime = that.pickObj.getsTimeC / 1000;
        that.pickObj.contact = this.factoryVal;
        that.pickObj.contactTel = this.telVal;
        that.pickObj.contactAdd = this.addressVal;
        that.pickObj.remark = this.ramakVal;
        that.pickupList.push(that.pickObj);
        if(that.pickObj.contact==""||that.pickObj.contactTel==""||that.pickObj.getsTime==""||that.pickObj.contactAdd==""){
          that.$message.error("请完善提货信息");
          tf = false;
        }
      };
      if (that.InsuranceVal) {
        if(that.insurancePeople==""||that.insuranceQuota==""||that.insuranceCurrency==""){
          that.$message.error("请完善保险信息");
          tf = false;
        }
      };
      if(tf){
        httpApi
          .addOrder({
            channelId: that.ruleForm.topChannel,
            clientNo: that.ruleForm.topWaybill.trim(),
            containerType: that.ruleForm.topOcean[1],
            declareType: that.ruleForm.topDeclare,
            dispatchPlace: that.ruleForm.cenPlace,
            dispatchId: that.ruleForm.cenId,
            dispatchTime: time,
            freightMethod: that.ruleForm.topOceanNum,
            goodsList: that.ruleForm.master_userArr,
            importerId: that.ruleForm.cenImporValue,
            importerType: that.ruleForm.cenImporVal,
            insurance: that.insurance,
            insuranceMan: that.insurancePeople,
            insuranceFee: that.insuranceQuota,
            insuranceCurrency: that.insuranceCurrency,
            insuranceShelf: that.shelf,
            pickupList: that.pickupList,
            pickupType: that.pickupType,
            shipmentAddress: that.ruleForm.address,
            shipmentState: that.ruleForm.state,
            shipmentCode: shipmentCode,
            shipmentContact: that.ruleForm.addressee,
            shipmentZip: that.ruleForm.addzip,
            shipmentCountry: that.ruleForm.country,
            shipmentList: that.ruleForm.order_user,
            shipmentTel: that.ruleForm.telPhone,
            shipmentType: that.radio,
            shipperId: that.ruleForm.cenDeliver,
            userRemark: that.ruleForm.inputValue
          })
          .then(res => {
            if (res.data.code == "ok") {
              that.$message.success("下单成功");
              that.orderVal = res.data.data;
              that.active = 3;
              that.ruleForm.dispatchTime = "";
              that.ruleForm.topWaybill = "";

              //如果有文件才保存文件
              if (this.responseDataUp){
                that.setFile(this.responseDataUp);
              }
            } else {
              that.$message.error(res.data.message);
            }
          });
      }
    },
    //送货时间
    dispatchTime() {
      var num = "";
      num = this.ruleForm.dispatchTime;
      this.ruleForm.dispatchTime = new Date(num).getTime();
      this.day = new Date(num).getTime();
      // var startAt = (new Date(this.ruleForm.dispatchTime) * 1000) / 1000;
      // if (startAt < Date.now()) {
      //   this.ruleForm.dispatchTime = new Date().getTime();
      // }
      if(!this.dialogFormVisible4){
        this.dialogFormVisible4 = true;
      }
      this.getTimeData();
    },
    setTime(times){
      let h = 3600000*times;
      if (this.ruleForm.dispatchTime!=null&&this.ruleForm.dispatchTime!=''){
        this.ruleForm.dispatchTime = this.day + h;
      }
    },
    getTimeData(){
      let time = this.ruleForm.dispatchTime / 1000;
      httpApi
        .getTimeData({
          params:{
            time: time,
            dispatchId: this.ruleForm.cenId
          }
        })
        .then(res=>{
          this.timeData = res.data.data
        })
    },
    //报关方式
    topDe(val) {
      if (this.ruleForm.topDeclare !== "买单") {
        this.ruleForm.topDeclVal = "1";
      }
      if (val == "0") {
        this.ruleForm.topDeclVal = "0";
      }
    },
    //海运方式拼柜整柜
    oceanShip() {
      for (let i in this.ruleForm.topOcean) {
        if (this.ruleForm.topOcean[i] == "拼柜") {
          this.ruleForm.topOceanNum = "0";
        } else if (this.ruleForm.topOcean[i] == "整柜") {
          this.ruleForm.topOceanType = this.ruleForm.topOcean[1];
          this.ruleForm.topOceanNum = "1";
        }
      }
    },
    //备注标签
    getTag(val) {
      this.ruleForm.inputValue += val + " ";
    },
    wareList() {
      httpApi.listParams({ params: { type: "sys_fbacode",enable:"1"} }).then(res => {
        if (res.data.code == "ok") {
          this.ruleForm.wareData = res.data.data;
          // this.addressInfo = this.ruleForm.wareData[0].address;
          for (let i in this.ruleForm.wareData) {
            this.ruleForm.wareData[i].lable =
              this.ruleForm.wareData[i].code +
              " " +
              this.ruleForm.wareData[i].zip;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    whList() {
      httpApi.listParams({ params: { type: "sys_wh",enable:"1" } }).then(res => {
        if (res.data.code == "ok") {
          this.ruleForm.whData = res.data.data;
          // that.addressInfo = that.ruleForm.whData[0].address;
          for (let i in this.ruleForm.whData) {
            this.ruleForm.whData[i].lable =
              this.ruleForm.whData[i].code + " " + this.ruleForm.whData[i].zip;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    whHoldList() {
      httpApi.listParams({ params: { type: "sys_wh_hold",enable:"1" } }).then(res => {
        if (res.data.code == "ok") {
          let whHoldData = [];
          let wholesaleData = [];
          // that.addressInfo = that.ruleForm.whHoldData[0].address;
          let resData = res.data.data;
          for (let i in resData) {
            resData[i].lable =
            resData[i].code + " " + resData[i].zip + " " + resData[i].serves;
            if(resData[i].serves.includes('自提')||resData[i].serves.includes('留仓')){
              whHoldData.push(resData[i]);
            }
            if(resData[i].serves.includes('一件代发')){
              wholesaleData.push(resData[i]);
            }
          }
          this.ruleForm.whHoldData = whHoldData;
          this.ruleForm.wholesaleData = wholesaleData;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getEndPortList() {

      httpApi
        .listParams( {
          params: {
            type: "sys_port",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.endPortList = res.data.data;
          }
        });

    },
    //订单类型查询
    listOrderType() {
      let that = this;
      httpApi
        .listParams({ params: { type: "sys_order_type",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            res.data.data.forEach(e=>{
              if(e.orderType=="0"){
                that.orderType0 = e.isEnable;
              }else if(e.orderType=="1"){
                that.orderType1 = e.isEnable;
              }else if(e.orderType=="2"){
                that.orderType2 = e.isEnable;
              }else if(e.orderType=="3"){
                that.orderType3 = e.isEnable;
              }else if(e.orderType=="4"){
                that.orderType4 = e.isEnable;
              }else if(e.orderType=="5"){
                that.orderType5 = e.isEnable;
              }
              if(e.isEnable&&Number(e.orderType)<that.radio){
                that.radio = Number(e.orderType);
                this.radioVal();
              }
            })
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //渠道查询
    listChannel() {
      httpApi.listParams2({
        params: {
          page: "",
          rows: "",
          channelName: "",
          channelType: "",
          enable: 1
        }
      }).then(res => {
        if (res.data.code == "ok") {
          res.data.data.forEach(element => {
            this.ruleForm.channelData.push({ label: element.label, options: element.list });
          });
        }
      });
    },
    //整柜查询
    listContainer() {
      httpApi
        .listParams({ params: { type: "sys_container_type",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.oceanData[1].children = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //送货地查询
    listPlaceOder() {
      let that = this;
      httpApi
        .getPort({ params: { type: "sys_dispatch_place" } })
        .then(res => {
          if (res.data.code == "ok") {
          res.data.data.forEach(element => {
            this.ruleForm.placeData.push({ label: element.label, options: element.list });
          });
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //地址
    radioVal() {
      if (this.radio == 0) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = "";
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.addressInfo="";
        this.addressInfo = "";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.wareCode[0].required = true;
        this.rules.whCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 1) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = true;
        this.rules.state[0].required = true;
        this.rules.addzip[0].required = true;
        this.rules.telPhone[0].required = true;
        this.rules.address[0].required = true;
        this.rules.country[0].required = true;
      } else if (this.radio == 2) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whCode[0].required = true;
        this.rules.wareCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 3){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whHoldCode[0].required = true;
        this.rules.wholesaleCode[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 4){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = true;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 5){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = true;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      }
    },
    //国家
    getCountry(e) {
      this.ruleForm.country = e;
    },
    //查询发货人
    deliverUser() {
      httpApi
        .queryUser({
          params: {
            type: 1
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.deliverData = res.data.data.rows;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //查询进口商
    importedUser() {
      httpApi
        .queryUser({
          params: {
            type: 0
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            // this.ruleForm.importedData = res.data.data.rows;
            this.ruleForm.cenImported = "公司进口商";
            this.ruleForm.cenImportext = "公司进口商";
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //进口商名字
    cen(val) {
      let obj = {};
      if (this.ruleForm.cenImported == "1") {
        this.ruleForm.cenImporVal = "1";
        this.ruleForm.cenImporValue = "";
        this.ruleForm.cenImportext = "公司进口商";
      } else {
        this.ruleForm.importedData.map(item => {
          if (item.id === val) {
            obj = item;
          }
        });
        this.ruleForm.cenImportext = obj.name + obj.address;
        this.ruleForm.cenImporValue = obj.id;
        this.ruleForm.cenImporVal = "0";
      }
    },
    //发货人名字
    cenDe(e) {
      let obj = {};
      this.ruleForm.deliverData.map(item => {
        //  this.importedData 是你 select option遍历的集合 e 是选中的id
        if (item.id === e) {
          obj = item;
        }
      });
      this.ruleForm.cenDelivertext = obj.name + obj.address;
    },
    //tag标签
    listTag() {
      httpApi
        .listParams({ params: { type: "sys_order_remark_tag",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            this.dynamicTags = res.data.data.map(item => {
              return item.name;
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //送货人名字
    cenPl(e) {
      let obj = {};
      this.ruleForm.placeData.map(item => {
        item.options.map(item2=>{
          if (item2.cname === e) {
            obj = item2;
            this.ruleForm.cenId = item2.id
          }
        })
      });
      this.textVal = obj.address;
    },
    //改变code地址
    wareDataAddress(e) {
      let obj = {};
      this.ruleForm.wareData.map(item => {
        //  this.importedData 是你 select option遍历的集合 e 是选中的id
        if (item.code === e) {
          obj = item;
        }
      });
      this.addressInfo = obj.address;
    },
    //上传excel表格
    async handProduct(response, file, fileList) {
      
      if(response.message !== "成功"){
        this.$message.error(response.message);
      }
      this.responseDataUp = response.data.upload;
      this.ruleForm.master_user.data = response.data.list;
      var goods = this.ruleForm.master_user.data;
      var goodsList = [];
      var shipmentData = [];
      for (var i = 0; i < goods.length; i++) {
        var g = {};
        var obj = goods[i];

        //有品名添加
        if(obj[1]!=""&&obj[1]!=null&&obj[1]!=undefined){
          if(obj[7]=="否"||obj[7]=="只带电"||obj[7]=="只带磁"||obj[7]=="带电带磁"){
            g.electrificationState = obj[7];
          }else{
            await this.$message.error("带电带磁格式错误");
            g.electrificationState = "";
          };
          if(obj[9]=="无品牌"||obj[9]=="境内自主品牌"||obj[9]=="境内收购品牌"||obj[9]=="境外品牌(贴牌生产)"||obj[9]=="境外品牌(其他)"){
            g.brandType = obj[9];
          }else{
            await this.$message.error("品牌类型格式错误");
            g.brandType = "";
          };
          g.name = obj[0];
          g.ename = obj[1];
          g.material = obj[2];
          g.purpose = obj[3];
          g.hscode = obj[4];
          g.gwcode = obj[5];
          g.taxRate = obj[6];
          g.brand = obj[8];
          g.model = obj[10];
          g.ctn = obj[11];
          g.qty = obj[12];
          g.unitValue = obj[13];
          g.totalValue = obj[14];
          g.size = obj[15] + "*" + obj[16] + "*" + obj[17];
          g.nkg = obj[18];
          g.kg = obj[19];
          g.cbm = obj[20];
          g.picUrl = obj.picUrl;
          g.markNo = obj[25];
          g.fnsku = obj[26];
          g.selleLink = obj[27];
          goodsList.push(g);
        }
        //有预约号添加
        if(obj[22]!=""&&obj[22]!=null&&obj[22]!=undefined){
          var s = {};
          s.shipmentid = obj[22];
          s.referenceid = obj[23];
          s.ctn = 0.00;
          s.kg = 0.00;
          s.cbm = 0.00;
          shipmentData.push(JSON.parse(JSON.stringify(s)));
        }
      }
      this.ruleForm.master_user.data = JSON.parse(JSON.stringify(goodsList));
      this.ruleForm.master_userArr = JSON.parse(JSON.stringify(goodsList));
      this.ruleForm.order_user = shipmentData;
      this.analysis();
    },
    setFile(response) {
      let that = this;
      let arr = response;
      httpApi
        .addFile({
          ext: arr.ext,
          name: arr.filename,
          orderNo: that.orderVal,
          size: arr.size,
          type: "5",
          url: arr.url
        });
    },
    analysis(){
      for (let i in this.ruleForm.master_userArr) {
        let numBT = this.ruleForm.master_userArr[i].brandType;//品牌类型解析
        switch(numBT){
          case "无品牌":
            this.ruleForm.master_userArr[i].brandType = "0"
            break;
          case "境内自主品牌":
            this.ruleForm.master_userArr[i].brandType = "1"
            break;
          case "境内收购品牌":
            this.ruleForm.master_userArr[i].brandType = "2"
            break;
          case "境外品牌（贴牌生产）":
            this.ruleForm.master_userArr[i].brandType = "3"
            break;
          case "境外品牌（其他）":
            this.ruleForm.master_userArr[i].brandType = "4"
            break;
        }
        let numES = this.ruleForm.master_userArr[i].electrificationState;//带电带磁解析
        switch(numES){
          case "否":
            this.ruleForm.master_userArr[i].electrificationState = "0"
            break;
          case "只带电":
            this.ruleForm.master_userArr[i].electrificationState = "1"
            break;
          case "只带磁":
            this.ruleForm.master_userArr[i].electrificationState = "2"
            break;
          case "带电带磁":
            this.ruleForm.master_userArr[i].electrificationState = "3"
            break;
        }
      }
    },
    //删除表格清空数据
    handRemove(){
      this.ruleForm.master_user.data = [];
      this.ruleForm.master_userArr = [];
    },
    //添加空数据
    addRow(){
      this.ruleForm.master_user.data.push(
        JSON.parse(JSON.stringify(this.goodsNullList))
      );
      this.ruleForm.master_userArr.push(
        JSON.parse(JSON.stringify(this.goodsNullList))
      );
    },
    //删除数据
    deleteRow(index, rows, rowsArr) {
      rows.splice(index, 1);
      rowsArr.splice(index, 1);
    },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 上传图片成功
    handleSuccess(response, file, fileList, index) {
      this.ruleForm.master_userArr[index].picUrl = response.data.url;
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1].raw]  // 这一步，是 展示最后一次选择的文件
      }
    },
    beforeUpload(file){
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('只能上传jpg或png格式的图片');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //预约号添加
    insert: function() {
      this.ruleForm.order_user.push(
        JSON.parse(JSON.stringify(this.ruleForm.order_userArr))
      );
      this.ruleForm.order_user[0].kg = "";
      this.ruleForm.order_user[0].ctn = "";
      this.ruleForm.order_user[0].cbm = "";
    },
    //预约号删除
    remove: function(index) {
      this.ruleForm.order_user.splice(index, 1);
    },
    //上门提货
    take() {
      if (this.takeVal) {
        this.pickupType = "1";
      } else {
        this.pickupType = "0";
      }
    },
    //保险
    Insurance() {
      if (this.InsuranceVal) {
        this.insurance = "1";
      } else {
        this.insurance = "0";
      }
    },
    //取货时间
    pickTime() {
      // this.pickObj.geteTime = new Date(this.creteTime[0]).getTime();
      this.pickObj.getsTimeC = new Date(this.creteTime).getTime();
    },
    // //下载唛头
    // getMaitou() {
    //   window.open(this.mApi + "/report/mai_tou?orderNo=" + this.orderVal);
    // },
    // //下载唛头
    getMaitou() {
      this.dialogFormVisible3 = true;
      this.init3();
    },
    getMaitou2(type) {
      this.dialogFormVisible3 = false;
      let typeFlag = type ? "a4" : "";
      window.open(
        this.mApi +
          "report/mai_tou3?orderNo=" + this.orderVal + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //下载入仓
    getRucangdan() {
      window.open(this.mApi + "/report/ru_cang_dan?orderNo=" + this.orderVal);
    },
    CopyOrderlist() {
      let that = this;
      httpApi
        .findOrder({ params: { orderNo: that.$route.query.orderNo } })
        .then(res => {
          if (res.data.code == "ok") {
            let arr = res.data.data.findOrderResponse;
            let chanpin = res.data.data.findOrderGoodsResponseList;
            that.ruleForm.topChannel = arr.channelId; 
            that.ruleForm.topDeclare = arr.declareType; 
            // that.ruleForm.cenPlace = arr.dispatchPlace; 
            that.ruleForm.cenImported = arr.importerName; 
            if (arr.shipmentType == "0") {
              that.radio = 0;
              that.radioVal();
              that.ruleForm.wareCode = arr.shipmentCode; 
            } else if (arr.shipmentType == "1") {
              that.radio = 1;
              that.radioVal();
              that.ruleForm.country = arr.shipmentCountry;
              that.ruleForm.addressee = arr.shipmentContact;
              that.ruleForm.state = arr.shipmentState;
              that.ruleForm.addzip = arr.shipmentZip;
              that.ruleForm.telPhone = arr.shipmentTel;
              that.ruleForm.address = arr.shipmentAddress;
            } else if(arr.shipmentType == "2") {
              that.radio = 2;
              that.radioVal();
              that.ruleForm.whCode = arr.shipmentCode;
            }else if(arr.shipmentType == "3") {
               that.radio = 3;
               that.radioVal();
               that.ruleForm.whHoldCode = arr.shipmentCode;
            }else if(arr.shipmentType == "4") {
               that.radio = 4;
               that.radioVal();
               that.ruleForm.endPort = arr.shipmentCode;
            }else{
               that.radio = 5;
               that.radioVal();
               that.ruleForm.wholesaleCode = arr.shipmentCode;
            }
            if (arr.freightMethod == "0") {
              that.ruleForm.topOcean = ["拼柜"];
              that.ruleForm.topOceanNum = "0";
            } else {
              that.ruleForm.topOcean = ["整柜", arr.containerType];
              that.ruleForm.topOceanNum = "1";
            }
            let a = that.ruleForm.placeData.find(i => {
              return i.cname == that.ruleForm.cenPlace;
            });
            if(a != undefined){
              that.ruleForm.cenPlace = arr.dispatchPlace;
              that.textVal = a.address;
            }

            let b = that.ruleForm.deliverData.find(i => {
              return i.name == arr.shipperName;
            });
            if (b == undefined || b == null || b == "") {
              that.ruleForm.cenDeliver = "";
            } else {
              that.ruleForm.cenDeliver = b.id; 
            }
            //产品申报
            that.ruleForm.master_user.data = chanpin;
            let goods = that.ruleForm.master_user.data;
            let goodsList = [];
            for (var i = 0; i < goods.length; i++) {
              var g = {};
              var obj = goods[i];
              g.name = obj.name;
              g.ename = obj.ename;
              g.material = obj.material;
              g.purpose = obj.purpose;
              g.hscode = obj.hscode;
              g.gwcode = obj.gwcode;
              g.taxRate = obj.taxRate;
              g.electrificationState = obj.electrificationState;
              g.brand = obj.brand;
              g.brandType = obj.brandType;
              g.model = obj.model;
              g.ctn = obj.ctn;
              g.qty = obj.qty;
              g.unitValue = obj.unitValue;
              g.totalValue = obj.totalValue;
              g.kg = obj.kg;
              g.size = obj.size;
              g.nkg = obj.nkg;
              g.kg = obj.kg;
              g.cbm = obj.cbm;
              g.picUrl = obj.picUrl;
              g.markNo = obj.markNo;
              g.fnsku = obj.fnsku;
              g.selleLink = obj.selleLink;
              goodsList.push(g);
            }
            that.ruleForm.master_user.data = JSON.parse(
              JSON.stringify(goodsList)
            );
            that.ruleForm.master_userArr = JSON.parse(
              JSON.stringify(goodsList)
            );
            for (let i in that.ruleForm.master_userArr) {
              that.ruleForm.master_userArr[i]["qty"] = parseInt(
                that.ruleForm.master_userArr[i]["qty"]
              );
              that.ruleForm.master_userArr[i]["ctn"] = parseInt(
                that.ruleForm.master_userArr[i]["ctn"]
              );
            }
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    async handShipmentId(response,file,fileList){

      if(response.message !== '成功'){
        this.$message.error(response.message);
      }else{

        let shipmentList = response.data
        let order_userList = [];
        for(let i in shipmentList){
          let order_userItem =  JSON.parse(JSON.stringify(this.ruleForm.order_userArr))
          order_userItem.shipmentid = shipmentList[i][0];
          order_userItem.referenceid = shipmentList[i][1]
          order_userItem.ctn = shipmentList[i][2]
          order_userItem.kg = shipmentList[i][3]
          order_userItem.cbm = shipmentList[i][4]
          order_userList.push(
            JSON.parse(JSON.stringify(order_userItem))
          );
        }
        this.ruleForm.order_user = order_userList
        // this.order_userArr.shipmentid = response.data.

      }

    },

    //添加已有产品
    addList() {
      this.dialogVisible = true;
      let that = this;
      httpApi
        .queryProduct({
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            name: that.inputVal
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.productData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    selectData(val) {
      this.selectDatas = val
    },
    add(){
      let arr = [];
      for (const i in this.selectDatas) {
        let obj = {};
        obj["name"] = this.selectDatas[i].name;
        obj["ename"] = this.selectDatas[i].ename;
        obj["material"] = this.selectDatas[i].material;
        obj["purpose"] = this.selectDatas[i].purpose;
        obj["hscode"] = this.selectDatas[i].hscode;
        obj["gwcode"] = this.selectDatas[i].gwcode;
        obj["taxRate"] = this.selectDatas[i].taxRate;
        obj["electrificationState"] = this.selectDatas[i].electrificationState;
        obj["brand"] = this.selectDatas[i].brand;
        obj["brandType"] = this.selectDatas[i].brandType;
        obj["model"] = this.selectDatas[i].model;
        obj["ctn"] = 1;
        obj["qty"] = 1;
        obj["unitValue"] = "";
        obj["totalValue"] = "";
        obj["nkg"] = "";
        obj["kg"] = "";
        obj["size"] = "";
        obj["cbm"] = "";
        obj["picUrl"] = this.selectDatas[i].picUrl;
        arr.push(obj)
      }
      this.ruleForm.master_user.data = [...this.ruleForm.master_user.data, ...arr];
      this.ruleForm.master_userArr = [...this.ruleForm.master_userArr, ...arr];
      this.analysis();
      this.dialogVisible = false;
    },
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.queryProduct();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.queryProduct();
    },
  },
  created() {
    this.wareList();
    this.whList();
    this.whHoldList();
    this.listOrderType();
    this.listChannel();
    this.deliverUser();
    this.importedUser();
    this.listContainer();
    this.listPlaceOder();
    this.getEndPortList();
    this.topDe();
    this.listTag();
    if (this.$route.query.orderNo) {
      this.CopyOrderlist();
    }
  },
  watch:{
    "ruleForm.master_userArr": {
      handler: function(val, old) {
        this.qty = 0;
        this.totalValue = 0;
        this.ruleForm.order_user[0].ctn = 0;
        this.ruleForm.order_user[0].kg = 0;
        this.ruleForm.order_user[0].cbm = 0;
        for (const i in val) {
          this.qty += Number(val[i].qty);
          this.totalValue += Number(val[i].totalValue);
          this.ruleForm.order_user[0].ctn += Number(val[i].ctn);
          this.ruleForm.order_user[0].kg += Number(val[i].kg);
          this.ruleForm.order_user[0].cbm += Number(val[i].cbm);
        };
        this.totalValue = this.totalValue.toFixed(2);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner{
  border-radius: 0;
}
/deep/.el-button.is-disabled.el-button--text{
  background:#f00 !important;
}
.grid-content{
  width: 100%;
  color: rgb(2, 2, 2);
  background: #40ff73;
  border-radius: 0;
}
/deep/.el-col{
  padding: 0 !important;
}
.orderby {
  width: auto;
  min-width: 1000px;
}
/deep/.el-card__body {
  padding: 0px 20px 20px;
  .el-steps {
    margin-top: 20px;
  }
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  display: flex;
  b,
  i {
    font-size: 14px;
  }
  i {
    margin-right: 5px;
  }
  .el-button {
    margin-left: 20px;
  }
}
/deep/.activeOne {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  /deep/.el-form-item {
    width: 200px;
    margin-bottom: 15px;
    .el-date-editor {
      width: 200px;
    }
  }
  .top {
    display: flex;
    margin-top: 10px;
    .text {
      p {
        width: 200px;
        margin-left: 95px;
      }
    }
    .lable {
      font-size: 13px;
      margin-left: 10px;
      font-weight: bold;
      width: 70px;
      text-align: right;
      display: inline-block;
    }
    .top-input {
      width: 320px;
    }
  }
  .radio {
    margin-top: 20px;
    .radio-cent + .radio-cent {
      margin-top: 20px;
    }
    .lable {
      font-size: 13px;
      margin-left: 10px;
      font-weight: bold;
      width: 70px;
      text-align: right;
      display: inline-block;
    }
    .el-radio-group {
      margin-left: 10px;
    }
    .el-form-item {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .upload-demo {
    width: auto;
    float: left;
    .el-upload-list {
      width: auto;
    }
  }
  .product {
    margin-top: 30px;
  }
  .subScribe {
    margin-top: 25px;
    width: 60%;
  }
}
/deep/.activeTwo {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  .switch {
    margin-top: 20px;
    display: flex;
    .el-switch + .el-switch {
      margin-left: 30px;
    }
    .sw_cent {
      width: 120px;
      display: flex;
      line-height: 20px;
      .label {
        width: 50px;
      }
    }
  }
  .take {
    margin-top: 20px;
    .take-cent {
      div {
        margin-top: 10px;
      }
      span {
        font-size: 13px;
        width: 80px;
        text-align: right;
        display: inline-block;
      }
      .el-input {
        width: 200px;
        margin-left: 20px;
      }
      .el-date-editor {
        margin-left: 20px;
        .el-input {
          width: 200px !important;
        }
      }
      .el-textarea {
        width: 30%;
        margin-left: 20px;
      }
      .take-time{
        position: relative;
        .el-icon-time{
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
  .insurance {
    margin-top: 20px;
    span {
      font-size: 13px;
      width: 80px;
      text-align: right;
      display: inline-block;
    }
    .el-input {
      width: 200px;
      margin-left: 20px;
      margin-right: 10px;
    }
    .el-tooltip {
      width: 22px;
      border-radius: 50%;
    }
  }
  .remake {
    margin-top: 20px;
    .span {
      display: inline-block;
      font-size: 13px;
      width: 60px;
      text-align: right;
    }
    .el-input {
      display: inline-block;
      width: 80%;
      margin-left: 20px;
    }
    .tag {
      margin-left: 20px;
      margin-top: 10px;
      cursor: pointer;
      .el-tag + .el-tag {
        margin-left: 10px;
      }
    }
  }
}
/deep/.activeThree {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  div {
    margin-top: 20px;
  }
}
// /deep/a {
//   color: #fff;
// }
table.gridtable {
  width: 720px;
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  .el-input {
    width: 100px;
    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0;
    }
  }
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
  .th {
    width: 100px;
    display: inline-block;
  }
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
}
.el-select-dropdown {
  min-width: 200px !important;
}
.bitian{
  font: 14px sans-serif;color:red
}
.el-input-number--small{
  width: 90px;
}
.tips{
  padding: 10px 0;
  font-weight: 600;
  text-align: left;
  span{
    margin-right: 20px;
  }
}
.red{
  color: #ff0000;
}
</style>